import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllSocialAction } from "../../../redux/action/socialAction";

const VolunteerPrograms = () => {
  const dispatch = useDispatch();

  const { allSocial, loading } = useSelector((state) => state.createSocial);

  useEffect(() => {
    dispatch(getAllSocialAction());
  }, [dispatch]);

  return (
    <div className="pl-3 sm:pl-10 pr-3 sm:pr-10 pt-10 pb-10 min-h-screen font-OpenSans bg-white text-black">
      {loading ? (
        <h1 className="text-center text-lg font-semibold">Loading...</h1>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
          {allSocial &&
            [...allSocial]
              .filter((item) => item.category.name === "volunteer programs")
              .sort(
                (a, b) =>
                  new Date(b.years).getFullYear() - new Date(a.years).getFullYear()
              )
              .map((item) => (
                <NavLink
                  key={item._id}
                  to={`/volunteer-programs/${item._id}`}
                  className="shadow-xl rounded overflow-hidden hover:shadow-2xl transition duration-300 ease-in-out bg-gray-50"
                >
                  <img
                    className="w-full h-60 object-cover"
                    src={item?.images[0]?.url}
                    alt={item.name}
                  />
                  <div className="p-4">
                    <h1 className="font-semibold text-sm sm:text-base uppercase mb-1">
                      {item.name} ({new Date(item.years).getFullYear()})
                    </h1>
                  </div>
                </NavLink>
              ))}
        </div>
      )}
    </div>
  );
};

export default VolunteerPrograms;
